module.exports = __webpack_public_path__ + "static/media/1017342.5029bea3.jpg";